import { gql } from '@apollo/client'

// mutation name added
export default gql(`
    mutation addVirtualAssetImages($imageContent: [AssetImageInput] $project: String $module: String!) {
        addVirtualAssetImages(
            input: $imageContent
            project: $project
            module: $module
        ) {
            id
            assetId
            mediaId
            isDefault
            fileName
            createdAt
            name
            type{
                name
                id
            }
            fileSize
            tags{
                key
                name
                type
            }
            category{
                id
                label
                type
            }
            settings {
                aspectRatio
                outputFormat
                fileName
                x1
                y1
                x2
                y2
            }
            dimensions{
                x1
                x2
                y1
                y2
            }
            aspectRatio {
                aspectRatio
                ratio
                title
                resolutions {
                key
                width
                height
                url
                }
            }
        }
    }`
)
